export default {
  'GET_GIFT' (state, payload) {
    if(payload.init) {
      state.Gifts = payload.payload
    }
    else {
      state.Gifts = state.Gifts.concat(payload.payload)
    }
  },
  'GET_CATEGORY' (state, payload) {
    state.Categorias = payload
  },
  'GET_PEDIDOS' (_, payload) {
    if(payload.init) {
      this.state.Clients.Pedidos = payload.payload
    }
    else {
      this.state.Clients.Pedidos = this.state.Clients.Pedidos.concat(payload.payload)
    }
  },
  'GET_PRODUCT' (state, payload) {
    state.Produtos = state.Produtos.concat(payload)
  },
  'GET_PRODUCT_SEARCH' (state, payload) {
    state.Produtos = payload
  },
  'SET_MODAL' (state, payload) {
    state.EnbModal = payload
  },
  'PUSH_IMG' (state, payload) {
    state.UploadImg.push(payload)
  },
  'UPDATE_ID_IMG' (state, payload) {
    state.UploadImg.map(i => {
      if(i.img === payload.img) {
        i.id = payload.id
      }
    })
  },
  'GET_LIB_IMG' (state, payload) {
    state.UploadImg = payload
  },
  'CHANGE_PRODEDIT' (state, payload) {
    for(let key in payload) {
      state.SelectedProdEdit[0][key] = payload[key]
    }
  },
  'TOFILE_PROD' (state, payload) {
    state.SelectedProdEdit.map(p => {
      if(p.id === payload.id) {
        p.status = payload.status
      }
    })
  },
  'CHANGESTATUS_PROD' (state, payload) {
    state.StatusProd = payload
  },
  'SET_PROD_CATEG' (state, payload) {
    //adicona categoria
    if(!payload.active) {
      let categ = JSON.parse(state.SelectedProdEdit[0].categoria)
      categ.push(payload.name)
      state.SelectedProdEdit[0].categoria = JSON.stringify(categ)
    }
    if(payload.active) {
      let categ = JSON.parse(state.SelectedProdEdit[0].categoria)
      categ = categ.filter(c => c !== payload.name)
      state.SelectedProdEdit[0].categoria = JSON.stringify(categ)
    }
  },
  'CHANGE_CATEGEDIT' (state, payload) {
    for(let key in payload) {
      state.SelectedCategEdit[key] = payload[key]
    }
  },
  'PUSH_CATEG' (state, payload) {
    state.Categorias.push(payload)
  },
  'PUSH_PRODEDIT' (state, payload) {
    if (state.SelectedProdEdit[0].id === '') {
      state.SelectedProdEdit[0] = payload
    } 
    else {
      state.SelectedProdEdit.push(payload)
    }
  },
  'DELETE_PRODEDIT' (state, payload) {
    let newList = state.SelectedProdEdit.filter(s => s.id !== payload.id)
    state.SelectedProdEdit = newList
    if (!state.SelectedProdEdit.length) {
      this.commit('CLEAR_PRODEDIT')
    }
  },
  'CLEAR_PRODEDIT' (state) {
    state.SelectedProdEdit = [{
      id: '',
      code: '',
      tipo: '',
      status: true,
      name: '',
      preco: 0,
      oferta: 0,
      img: [],
      descricao: '',
      dateOfertaStart: '',
      dateOfertaEnd: '',
      categoria: '[]',
      gerEstoque: false,
      statusEstoque: '',
      estoque: 0,
      pendencia: '',
      visibilidade: 1,
      visualizacao: 0,
      atributos: [],
      estoqueVariavel: [],
      caracter: [],
      destaque: false
    }]
  },
  PUSH_ALLEDIT (state, payload) {
    state.SelectedProdEdit = payload
  },
  'PUSH_PROPPROD' (state, payload) {
    state.SelectedProdEdit[0].atributos.push(payload)
  },
  'DELETE_ATR' (state, payload) {
    state.SelectedProdEdit[0].atributos = state.SelectedProdEdit[0].atributos
      .filter(a => a.id !== payload)
  },
  'DELETE_ATR_VALUE' (state, payload) {
    for(let key in state.SelectedProdEdit[0].atributos) {
      state.SelectedProdEdit[0].atributos[key].values = state.SelectedProdEdit[0].atributos[key].values
        .filter(v => v.id !== payload)
    }
  },
  'UPDATE_PROPPROD' (state, payload) {
    state.SelectedProdEdit[0].atributos.map(p => {
      if(p.id === payload.id) {
        p.active = !payload.active
      }
    })
  },
  'UPDATE_VALUEPROP' (state, payload) {
    let prop = state.SelectedProdEdit[0].atributos.filter(p => p.id === payload.prop.id)[0]
    prop.values.map(v => {
      if (v.id === payload.value.id) {
        v.active = !payload.value.active
      }
    })
  },
  'CHANGE_GIFT_EDIT' (state, payload) {
    for(let key in payload) {
      state.SelectedGiftEdit[key] = payload[key]
    }
  },
  'PUSH_GIFT' (state, payload) {
    state.Gifts.push(payload)
  },
  'SET_GIFT_EDIT' (state, payload) {
    state.SelectedGiftEdit = payload
  },
  'DELETE_GIFT' (state, payload) {
    console.log(payload)
    state.Gifts = state.Gifts.filter(g => g.id !== payload.id)
  },
  'PUSH_ESTOQUE_VARIAVEL' (state, payload) {
    state.SelectedProdEdit[0].estoqueVariavel.push(payload)
  },
  'UPDATE_ESTOQUE' (state, payload) {
    state.SelectedProdEdit[0].estoque = payload
  },
  'DELETE_ESTOQUE_VARIAVEL' (state, payload) {
    state.SelectedProdEdit[0].estoqueVariavel = state.SelectedProdEdit[0].estoqueVariavel
      .filter(e => e.id !== payload.id)
  },
  'UPDATE_ESTOQUE_QTDE' (state, payload) {
    state.SelectedProdEdit[0].estoqueVariavel.map(e => {
      if(e.id === payload.id) {
        e.src.quantidade = payload.quantidade
      }
    })
  },
  'CLEAR_GIFT_EDIT' (state) {
    state.SelectedGiftEdit = {
      codigo: '',
      tipo: '',
      valor: 0,
      validade: '',
      gastoMin: 0,
      gastoMax: 0,
      produtos: [],
      produtoDel: [],
      categorias: [],
      categoriasDel: [],
      emails: '',
      limiteCupom: 0,
      limiteNprodutos: 0,
      limiteUser: 0,
      freteGratis: false,
      individual: false,
      itensVendaDel: false
    }
  },
  'PUSH_CARACTER_PROD' (state, payload) {
    state.SelectedProdEdit[0].caracter.push(payload)
  },
  'DEL_CARACTER_PROD' (state, payload) {
    state.SelectedProdEdit[0].caracter = state.SelectedProdEdit[0].caracter.filter(c => c.id != payload.id)
  },
  'SET_ICON' (state, payload) {
    state.SelectedCategEdit.icon = payload
  },
  'DELETE_PROD' (state, payload) {
    for(let key in payload) {
      this.state.Theme01.ProdutosStore = this.state.Theme01.ProdutosStore.filter(p => p.id !== payload[key].id)
      state.Produtos = state.Produtos.filter(p => p.id !== payload[key].id)
    }
  },
  'UPDATE_PAYMODE' (state, payload) {
    for(let key in payload) {
      this.state.System.Empresa[key] = payload[key]
    }
  },
  'CHANGE_COMPANY' (state, payload) {
    for(let key in payload) {
      this.state.System.Empresa[key] = payload[key]
    }
  },
  'CHANGE_GIFTVALIDATE' (state, payload) {
    for(let key in payload) {
      state.GiftValidate[key] = payload[key]
    }
  },
  'CHANGE_FILTER_PROD_PAINEL' (state, payload) {
    for(let key in payload) {
      state.FilterProdPainel[key] = payload[key]
    }
  },
  'CHANGE_FRETE' (state, payload) {
    for(let key in payload) {
      state.Frete[key] = payload[key]
    }
  },
  'PUSH_FRETE_TABELA_BAIRRO' (state, payload) {
    state.FreteTabelaBairro.push(Object.assign({}, payload))
  },
  'DEL_FRETE_TABELA_BAIRRO' (state, payload) {
    state.FreteTabelaBairro = state.FreteTabelaBairro.filter(t => t.id !== payload.id)
  },
  'GET_FRETE' (state, payload) {
    payload.valor = payload.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
    payload.valormin = payload.valormin.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
    payload.gratisapartir = payload.gratisapartir.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
    state.Frete = payload
  },
  'GET_FRETE_BAIRRO' (state, payload) {
    for(let key in payload) {
      payload[key].valor = payload[key].valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
      payload[key].gratisapartir = payload[key].gratisapartir.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
    }
    state.FreteTabelaBairro = payload
  },
  'GET_PRODUTO_STATUS' (state, payload) {
    if(payload.status) {
      state.ProdutoStatus.publicados = payload.value
    } else {
      state.ProdutoStatus.arquivados = payload.value
    }
  }
}
